import LocalizedStrings from "react-localization";

export const globalStrings = new LocalizedStrings({
  es: {
    permissions: {
      "company:create": "Crear Empresa",
      "company:update": "Actualizar Empresa",
      "company:read": "Leer Empresas",
      "company:delete": "Eliminar Empresa",
      "company-branch:create": "Crear Sede de Empresa",
      "company-branch:update": "Actualizar Sede de Empresa",
      "company-branch:read": "Leer Sedes de Empresa",
      "company-branch:delete": "Eliminar Sede de Empresa",
      "role:create": "Crear Rol",
      "role:update": "Actualizar Rol",
      "role:read": "Leer Roles",
      "role:delete": "Eliminar Rol",
      "device:create": "Crear Dispositivo",
      "device:update": "Actualizar Dispositivo",
      "device:read": "Leer Dispositivos",
      "device:delete": "Eliminar Dispositivo",
      "device:read-action-logs": "Ver Historial de Acciones del Dispositivo",
      "device:execute-actions": "Ejecutar Acciones del Dispositivo",
      "device:read-calibration": "Leer Calibración del Dispositivo",
      "dashboard:read": "Leer Tableros Personalizados",
      "dashboard:read-standard": "Leer Tablero Estándar",
      "user:read": "Leer Usuarios",
      "user:update": "Actualizar Usuario",
      "variable:create": "Crear Variable",
      "variable:update": "Actualizar Variable",
      "variable:read": "Leer Variables",
      "variable:delete": "Eliminar Variable",
      "monitor:read": "Leer Central de Monitoreo",
      "action:create": "Crear Acción",
      "action:update": "Actualizar Acción",
      "action:read": "Leer Acciones",
      "action:delete": "Eliminar Acción",
      "alert:create-config": "Crear Configuración de Alerta",
      "alert:update-config": "Actualizar Configuración de Alerta",
      "alert:read-config": "Leer Configuración de Alertas",
      "alert:delete-config": "Eliminar Configuración de Alerta",
      "alert:read": "Leer Alertas",
      "alert:recognize": "Reconocer Alerta",
      "rule:create-config": "Crear Configuración de Regla",
      "rule:update-config": "Actualizar Configuración de Regla",
      "rule:read-config": "Leer Configuración de Reglas",
      "rule:delete-config": "Eliminar Configuración de Regla",
      "rule:read": "Leer Reglas",
      "store:read": "Leer Tienda",
      "message:read": "Leer Centro de Mensajes",
      "diagram:read": "Leer Planos y Diagramas",
      "maintenance-dashboard:read": "Leer Tableros de Mantenimiento",
      "equipment:create": "Crear Equipo",
      "equipment:update": "Actualizar Equipo",
      "equipment:delete": "Eliminar Equipo",
      "equipment:read": "Leer Equipos",
      "equipment:create-param": "Crear Parámetro de Equipo",
      "equipment:update-param": "Actualizar Parámetro de Equipo",
      "equipment:delete-param": "Eliminar Parámetro de Equipo",
      "equipment:read-param": "Leer Parámetros de Equipo",
      "equipment:create-doc": "Crear Documento de Equipo",
      "equipment:update-doc": "Actualizar Documento de Equipo",
      "equipment:delete-doc": "Eliminar Documento de Equipo",
      "equipment:read-doc": "Leer Documentos de Equipo",
      "equipment:export": "Exportar Equipo",
      "tool:create": "Crear Herramienta",
      "tool:update": "Actualizar Herramienta",
      "tool:delete": "Eliminar Herramienta",
      "tool:read": "Leer Herramientas",
      "tool:create-param": "Crear Parámetro de Herramienta",
      "tool:update-param": "Actualizar Parámetro de Herramienta",
      "tool:delete-param": "Eliminar Parámetro de Herramienta",
      "tool:read-param": "Leer Parámetros de Herramienta",
      "maintenance-requirement:read": "Leer Solicitudes de Mantenimiento",
      "service-order:create": "Crear Orden de Servicio",
      "service-order:update": "Actualizar Orden de Servicio",
      "service-order:delete": "Eliminar Orden de Servicio",
      "service-order:execute": "Ejecutar Orden de Servicio",
      "service-order:export": "Exportar Orden de Servicio",
      "service-order:read": "Leer Ordenes de Servicio",
      "service-order:cancel": "Anular Orden de Servicio",
      "service-order:upload-photo": "Subir Foto de Orden de Servicio",
      "service-order:delete-photo": "Eliminar Foto de Orden de Servicio",
      "service-order:read-photo": "Leer Fotos de Orden de Servicio",
      "cost-center:create": "Crear Centro de Costo",
      "cost-center:update": "Actualizar Centro de Costo",
      "cost-center:delete": "Eliminar Centro de Costo",
      "cost-center:read": "Leer Centros de Costo",
      "maintenance-schedule:read": "Leer Programas de Mantenimiento",
      "spare:create": "Crear Repuesto",
      "spare:update": "Actualizar Repuesto",
      "spare:delete": "Eliminar Repuesto",
      "spare:read": "Leer Repuestos",
      "spare:create-param": "Crear Parámetro de Repuesto",
      "spare:update-param": "Actualizar Parámetro de Repuesto",
      "spare:delete-param": "Eliminar Parámetro de Repuesto",
      "spare:read-param": "Leer Parámetros de Repuesto",
      "income-and-expense:read": "Leer Analizador de Ingresos y Costos",
      "failure-analytic:read": "Leer Analítica de Fallas",
      "report:read": "Leer Reportes",
      "forecast:read": "Leer Predicciones",
      "data-exporter:read": "Leer Exportador de Datos",
      "parameter:create": "Crear Parámetro",
      "parameter:update": "Actualizar Parámetro",
      "parameter:delete": "Eliminar Parámetro",
      "parameter:read": "Leer Parámetros",
      "work-routine:read": "Leer Rutinas de Trabajo",
      "group:read": "Leer Grupos",
      "maintenance-routine:create": "Crear Rutina de Mantenimiento",
      "maintenance-routine:update": "Actualizar Rutina de Mantenimiento",
      "maintenance-routine:delete": "Eliminar Rutina de Mantenimiento",
      "maintenance-routine:read": "Leer Rutinas de Mantenimiento",
      "maintenance-routine:create-act": "Crear Actividad de Rutina de Mantenimiento",
      "maintenance-routine:update-act": "Actualizar Actividad de Rutina de Mantenimiento",
      "maintenance-routine:delete-act": "Eliminar Actividad de Rutina de Mantenimiento",
      "maintenance-routine:read-act": "Leer Actividades de Rutina de Mantenimiento",
      "technician:role": "Técnico (Rol)"
    },
    noResults: "No hay resultados",
    dateItems: {
      custom: "Personalizado",
      lastHour: "Última hora",
      today: "Hoy",
      yesterday: "Ayer",
      thisWeek: "Esta semana",
      last7Days: "Últimos 7 días",
      last14Days: "Últimos 14 días",
      last30Days: "Últimos 30 días",
      last60Days: "Últimos 60 días",
      thisYear: "Este año",
      lastValue: "Último valor",
    },
    scheduleTypes: {
      "12Hours": "AM/PM",
      "24Hours": "24 Horas",
    },
    selectOption: "Seleccione una opción",
    severity: {
      options: {
        1: "Alto",
        2: "Medio",
        3: "Bajo",
      },
    },
    timePeriodicity: {
      monthly: "Mensual",
      weekly: "Semanal",
      daily: "Diario",
      hourly: "Cada hora",
      realtime: "Tiempo real",
    },
    lastTime: {
      lastMinutes: "Últimos minutos",
      lastHours: "Últimas horas",
      lastDays: "Últimos días",
      lastWeeks: "Últimas semanas",
      lastMonths: "Últimos meses",
    },
    minutes: "Minutos",
    hour: "Hora",
    hours: "Horas",
    day: "Día",
    days: "Días",
    week: "Semana",
    weeks: "Semanas",
    month: "Mes",
    months: "Meses",
    today: "Hoy",
    previous: "Anterior",
    next: "Siguiente",
    yes: "Sí",
    not: "No",
    valueTypes: {
      none: "Ninguno",
      list: "Lista",
      number: "Numérico",
    },
    dayNames: {
      monday: "Lunes",
      tuesday: "Martes",
      wednesday: "Miércoles",
      thursday: "Jueves",
      friday: "Viernes",
      saturday: "Sábado",
      sunday: "Domingo",
    },
    operators: {
      "<": "Menor",
      "<=": "Menor o igual",
      "==": "Igual",
      ">=": "Mayor o igual",
      ">": "Mayor",
      "!=": "Diferente",
    },
    on: "Encendido",
    off: "Apagado",
    currency: {
      COP: "COP",
      USD: "USD",
      SVC: "SVC",
      BTN: "BTN",
    },
    serviceOrderStatus: {
      created: "Creada",
      scheduled: "Programada",
      executed: "Ejecutada",
      canceled: "Anulada",
      executing: "En Ejecución",
    },
    spareStatus: {
      available: "Disponible",
      assignedInOrder: "Asignado en Orden de Servicio",
      installedInEquipment: "Instalado en Equipo",
    },
  },
});
